// import '../css/landing.css';
// import main from '../assets/landingpages.png';
// import { useNavigate } from 'react-router-dom';
// import { motion } from "framer-motion";

// export default function Landing() {
//     const navigate = useNavigate();
//     return (
//         <div className="landing">
//             <span className="left">
//                 <div className="tree">
//                     <ul>
//                         <li>
//                             <div className="node">
//                             የዓብይ ኮሚቴ / የሥራ አስፈፃሚ ኮሚቴ/ 
//                             </div>
//                             <ul>
//                                 <li>
//                                 <div className="node"> 
//                                     የጽ/ቤት / የሥራ አመራር ኮሚቴ / አባላት  
//                                 </div>
//                                     <ul><div className="node">
//                                     የማህበሩ ሰብሳቢ
//                                     </div>
//                                     <ul>
//                                        <li>
//                                        <div className="node">
//                                        ምክትል ሰብሳቢ
//                                          <div className="description">
//                                            የገቢ ምንጮችን ማፈላለግ፣ ገቢ ማሰባሰብ፣ የዳግም ትንሳኤ ፕሮግራምን በቀመቀ
//                                            መልኩ ለማክበር የምደረጉ ስራዎች፣ የጉዞ ፕሮግራሞች፣ ወዘተ                                                
//                                         </div>
//                                        </div>
//                                        </li>
//                                        <li>
//                                        <div className="node">
//                                        ፀሐፊ
//                                          <div className="description">
//                                            የማህበሩ ፀሐፊ ተጠሪነቱ ለዋና ሰብሳቢው ነው፡፡  
//                                            ከምክትል ሰብሳቢው ጋር በመሆን የስብሰባ አጀንዳዎችን ይቀርፃል፡፡ 
//                                            የማህበሩን ማህተም ይይዛል፡፡ 
//                                            ማንኛውም ወደ ማህበሩ የሚገቡ ደብዳቤዎችን ይቀበላል ለዋናው ሰብሳቢው ይመራል ከአገልግሎች ክፍሎች በሚመጣ ደብዳቤ መሠረት በደረሰኞች ላይ ማህተም ያደርጋል፡፡ 
//                                            ከማህበሩ የሚወጡ ደብዳቤዎችንና ዶክሜንቶችን ያረቃል፡፡ 
//                                            በስብሰባ ወቅት ቃለ ጉባኤ ይይዛል፤ አርቅቆ ይጽፋል፣ በኮምፒተር እንዲፃፍ አድርጎ ለሚቀጥለው ስብሰባ ቀን ለፊርማ ያዘጋጃል፡፡            
//                                          </div>
//                                        </div>
//                                        </li>
//                                        <li>
//                                        <div className="node">
//                                         አገልግሎት ክፍሎች 
//                                             <div className="description">
//                                                 መዘምራንን ያደራጃል፣ ያሰለጥናል፣ የመዝሙር አገልግሎት በመንፈሳዊ ስርአት
//                                                 ለሚፈፅሙ ይሰጣል፣ በጥምቀት በአል ላይ የመዝሙር አግልግሎት ይሰጣል፣
//                                             </div>
//                                        </div>
//                                          <ul>
//                                            <li>
//                                             <div className="node">
//                                             ትምህርት ክፍል 
//                                                 <div className="description">
//                                                 የገቢ ምንጮችን ማፈላለግ፣ ገቢ ማሰባሰብ፣ የዳግም ትንሳኤ ፕሮግራምን በቀመቀ
//                                                 መልኩ ለማክበር የምደረጉ ስራዎች፣ የጉዞ ፕሮግራሞች፣ ወዘተ                                                
//                                                 </div>
//                                             </div>
//                                             <ul>
//                                                   <li>
//                                                   <div className="node">
//                                                      ስልጠና ንዑስ ክፍል 
//                                                      <div className="description">
//                                                        የገቢ ምንጮችን ማፈላለግ፣ ገቢ ማሰባሰብ፣ የዳግም ትንሳኤ ፕሮግራምን በቀመቀ
//                                                        መልኩ ለማክበር የምደረጉ ስራዎች፣ የጉዞ ፕሮግራሞች፣ ወዘተ                                                
//                                                        </div>
//                                                    </div>
//                                                   </li>
                                                
//                                                   <li>
//                                                   <div className="node">
//                                                   አርትኦት ንዑስ ክፍል  
//                                                      <div className="description">
//                                                        የገቢ ምንጮችን ማፈላለግ፣ ገቢ ማሰባሰብ፣ የዳግም ትንሳኤ ፕሮግራምን በቀመቀ
//                                                        መልኩ ለማክበር የምደረጉ ስራዎች፣ የጉዞ ፕሮግራሞች፣ ወዘተ                                                
//                                                        </div>
//                                                    </div>
//                                                   </li>
                                                
//                                                   <li>
//                                                   <div className="node">
//                                                   ህትመት ንዑስ ክፍል  
//                                                      <div className="description">
//                                                        የገቢ ምንጮችን ማፈላለግ፣ ገቢ ማሰባሰብ፣ የዳግም ትንሳኤ ፕሮግራምን በቀመቀ
//                                                        መልኩ ለማክበር የምደረጉ ስራዎች፣ የጉዞ ፕሮግራሞች፣ ወዘተ                                                
//                                                        </div>
//                                                    </div>
//                                                   </li>
                                            
//                                                   <li>
//                                                   <div className="node">
//                                                   ምክር አገልግሎት ንዑስ ክፍል  
//                                                      <div className="description">
//                                                        የገቢ ምንጮችን ማፈላለግ፣ ገቢ ማሰባሰብ፣ የዳግም ትንሳኤ ፕሮግራምን በቀመቀ
//                                                        መልኩ ለማክበር የምደረጉ ስራዎች፣ የጉዞ ፕሮግራሞች፣ ወዘተ                                                
//                                                        </div>
//                                                    </div>
//                                                   </li>
//                                                 </ul>
//                                             </li> 
//                                             <li>
//                                           <div className="node">
//                                           መዝሙርና  ኪነጥበብ ክፍል 
//                                               <div className="description">
//                                               ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                   </div>
//                                           </div>
//                                                 <ul>
//                                                 <li>
//                                                         <div className="node">
//                                                         መዝሙር ንዑስ ክፍል 
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                     <li>
//                                                         <div className="node">
//                                                         የኪነ-ጥበብ ንዑስ ክፍል  
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li>
//                                                </ul>
//                                        </li>  
//                                        <li>
//                                           <div className="node">
//                                           ልማት ክፍል 
//                                               <div className="description">
//                                               ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                   </div>
//                                           </div>
//                                                 <ul>
//                                                 <li>
//                                                         <div className="node">
//                                                         ዕድገት ንዑስ ክፍል  
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                     <li>
//                                                         <div className="node">
//                                                         የጉዞ ንዑስ ክፍል  
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li>
//                                                     <li>
//                                                         <div className="node">
//                                                         ምግባረ ሰናይ ንዑስ ክፍል  
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                </ul>
//                                        </li> 
//                                        <li>
//                                           <div className="node">
//                                           ግንኙነት ክፍል 
//                                               <div className="description">
//                                               ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                   </div>
//                                           </div>
//                                                 <ul>
//                                                 <li>
//                                                         <div className="node">
//                                                         አባላት ክትትል ንዑስ ክፍል  
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                     <li>
//                                                         <div className="node">
//                                                         የውጭ ግንኙነት ንዑስ ክፍል   
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li>
//                                                     <li>
//                                                         <div className="node">
//                                                         መረጃና መዛግብት ንዑስ ክፍል  
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                </ul>
//                                        </li>  
//                                        <li>
//                                           <div className="node">
//                                           ሒሳብ እና ንብረት ክፍል 
//                                               <div className="description">
//                                               ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                   </div>
//                                           </div>
//                                                 <ul>
//                                                 <li>
//                                                         <div className="node">
//                                                         ሒሳብ ንዑስ ክፍል   
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                     <li>
//                                                         <div className="node">
//                                                         ንብረት ንዑስ ክፍል   
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li>
//                                                     <li>
//                                                         <div className="node">
//                                                         መርሐግብር ክፍል  
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                </ul>
//                                        </li> 
//                                        <li>
//                                           <div className="node">
//                                           የአብነት ት/ቤቶች ድጋፍ ክፍል
//                                               <div className="description">
//                                               ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                   </div>
//                                           </div>
//                                                 <ul>
//                                                 <li>
//                                                         <div className="node">
//                                                         የኦዲዮ ቪዥዋል ን/ክፍል   
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                     <li>
//                                                         <div className="node">
//                                                         የት/ት እና ቅስቀሳ ን/ክፍል    
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li>
//                                                     <li>
//                                                         <div className="node">
//                                                         የገቢ አሰባሰብ ን/ክፍል  
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                     <li>
//                                                         <div className="node">
//                                                         ስርጭት እና ጥናት ን/ክፍል  
//                                                            <div className="description">
//                                                             ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                                                </div>
//                                                         </div>
//                                                     </li> 
//                                                </ul> 
//                                        </li> 
//                                     </ul>    
//                                 </li>
//                             </ul>
//                                 </ul>
//                                 </li>
//                                 <li>
//                                   <div className="node">
//                                   ቶራ የበጎ አድራጎት ድርጅት
//                                       <div className="description">
//                                       ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                           </div>
//                                   </div>
                                        
//                                </li>   
//                                <li>
//                                   <div className="node">
//                                   ኦዲት እና  ኢንስፔክሸን
//                                       <div className="description">
//                                       ገዳማትን እና በገዳማት ውስጥ የሉ የአብነት ተማሪዎችን መርዳት                          
//                                           </div>
//                                   </div>
                                        
//                                </li>  
//                             </ul>
//                         </li>
//                     </ul>
//                 </div>
//             </span>
//             <span className="right">
//                 <div className="organization-description">
//                     <h2>የማህበሩ አወቃቀር</h2>
//                     <p>
//                         የማህበሩ አወቃቀር በአጠቃላይ ስም እና በተመረጡ ስራዎች ላይ ስለሚሰሩ መረጃ እና መንገዶች በማህበሩ አካላት የተመለከቱ መረጃ ነው። እሱም ምክንያቶችን፣ ስራዎችን፣ ማህበሩን በሚለው አውታረ ብርሃንን አቀረበ። 
//                     </p>
//                     <p>
//                         ማህበሩ አካላት ይህንን እና እንዲሁም ሌሎች ምሳሌዎችን ለማንኛውም ማህበረሰብ ለአሁን ስራዎች እና ለመንገድ እና በጉባኤው ምላተ ጉባኤው ስም ተመሳሳይ እንደተወከለ መረጃ ስለሆነ የተጠቀሱ ሁሉም መረጃዎች፣ በዚህ በኩል በምላተ ጉባኤው የተስፋፋ በሚለው መሠረት ተመርሷል። 
//                     </p>
//                 </div>
//             </span>
//         </div>
//     );
// }

import React, { useState } from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../css/landing.css";

// Recursive Node Component
const TreeNode = ({ node }) => {
    const [expanded, setExpanded] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
  
    return (
      <li>
        <div 
          className="node" 
          onClick={() => setExpanded(!expanded)} 
          onMouseEnter={() => node.description && setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          {node.children && (
                    <i 
                        className={`bi ${expanded ? "bi-chevron-down" : "bi-chevron-right"}`} 
                        style={{ marginRight: "5px" }}
                    ></i>
                )}
          {node.name}
          {node.description && (
          <div className={`tooltip ${showTooltip ? "visible" : ""}`}>
            {node.description}
          </div>)}
        </div>
        {expanded && node.children && (
          <ul>
            {node.children.map((child, index) => (
              <TreeNode key={index} node={child} />
            ))}
          </ul>
        )}
      </li>
    );
  };

// Data for Organizational Hierarchy
const organizationData = {
    name: "የዓብይ ኮሚቴ / የሥራ አስፈፃሚ ኮሚቴ/",
    description:
      "የማህበሩን ጠቅላላ እንቅስቃሴ በበላይነት ይመራል፡፡",
    children: [
      {
        name: "የጽ/ቤት / የሥራ አመራር ኮሚቴ / አባላት",
        description:
          "የጽ/ቤት ወይም የሥራ አመራር የሚባሉት የማህበሩ ዋና ሰብሳቢ ምክትል ሰብሳቢ እና ፀሐፊ ናቸው፡፡",
        children: [
          {
            name: "የማህበሩ ሰብሳቢ",
            description:
              "የማህበሩ ሰብሳቢ ተጠሪነቱ በቀጥታ ለጠቅላላ ጉባኤው ነው፡፡",
            children: [
              {
                name: "ምክትል ሰብሳቢ",
                description:
                  "ም/ሰብሳቢው ተጠሪነቱ ለዋናው ሰብሳቢ ነው፡፡"
              },
              {
                name: "ፀሐፊ",
                description:
                  "የማህበሩ ፀሐፊ ተጠሪነቱ ለዋና ሰብሳቢው ነው፡፡"
              },
              {
                name: "አገልግሎት ክፍሎች",
                description:
                  "ማህበሩ በስሩ ባሉት 8 ዋና ዋና ክፍሎች አገልግሎቶቹን ይፈጽማል፡፡",
                      children: [
                        {
                            name: "ትምህርት ክፍል",
                            description:
                              "የትምህርት ክፍል ኃላፊ ተጠሪነቱ በቀጥታ ለዋና ሰብሳቢ ነው፡፡",
                              children: [
                                  {
                                    name: "ስልጠና ንዑስ ክፍል",
                                    description:
                                      "የስልጠና ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለትምህርት ክፍል ኃላፊ ነው፡፡"
                                  },
                                  {
                                    name: "አርትኦት ንዑስ ክፍል",
                                    description:
                                      "የአርትኦት ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለትምህርት ክፍል ኃላፊ ይሆናል፡፡"
                                  },
                                  {
                                    name: "ህትመት ንዑስ ክፍል",
                                    description:
                                      "የህትመት ክፍል ኃላፊ ተጠሪነቱ ለትምህርት ክፍል ኃላፊ ነው፡፡"
                                  },
                                  {
                                      name: "ምክር አገልግሎት ንዑስ ክፍል",
                                      description:
                                        "የምክር አገልግሎች ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለትምህርት ክፍል ኃላፊ ይሆናል፡፡"
                                  }
                                ]
                            },
                            {
                                name: "መዝሙርና  ኪነጥበብ ክፍል",
                                description:
                                  "የመዝሙርና ኪነጥበብ ክፍል ኃላፊ ተጠሪነቱ በቀጥታ ለዋና ሰብባቢው ነው፡፡",
                                  children: [
                                      {
                                        name: "መዝሙር ንዑስ ክፍል",
                                        description:
                                          "የመዝሙር ክፍል ኃላፊ ተጠሪነቱ ለመዝሙርና ኪነጥበብ ክፍል ኃላፊ ነው፡፡"     
                                      },
                                      {
                                        name: "የኪነ-ጥበብ ንዑስ ክፍል",
                                        description:
                                          "የኪነጥበብ ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለመዝሙርና ኪነጥበብ ክፍል ኃላፊ ነው፡፡"
                                      }
                                    ]
                                },
                                {
                                    name: "ልማት ክፍል",
                                    description:
                                      "የልማት ክፍል ኃላፊ ተጠሪነቱ ለዋና ሰብባቢው ነው፡፡",
                                      children: [
                                          {
                                            name: "ዕድገት ንዑስ ክፍል",
                                            description:
                                              "የዕድገት ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለልማት ክፍል ኃላፊ ነው፡፡",
                                              
                                          },
                                          {
                                            name: "የጉዞ ንዑስ ክፍል",
                                            description:
                                              "የጉዞ ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለልማት ክፍል ኃላፊ ነው፡፡"
                                          },
                                          {
                                            name: "ምግባረ ሰናይ ንዑስ ክፍል",
                                            description:
                                              "የምግባረ ሰናይ ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለልማት ክፍል ኃላፊ ነው፡፡"
                                          }
                                        ]
                                    },
                                    {
                                        name: "ግንኙነት ክፍል",
                                        description:
                                          "የግንኙነት ክፍል ኃላፊ ተጠሪነቱ ለዋና ሰብሳቢ ነው፡፡",
                                          children: [
                                              {
                                                name: "አባላት ክትትል ንዑስ ክፍል",
                                                description:
                                                  "የአባላተ ክትትል ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለግንኙነት ክፍል ኃላፊ ነው፡፡",
                                                  
                                              },
                                              {
                                                name: "የውጭ ግንኙነት ንዑስ ክፍል",
                                                description:
                                                  "የውጭ ግንኙነት ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለግንኙነት ክፍል ኃላፊ ነው፡፡"
                                              },
                                              {
                                                name: "መረጃና መዛግብት ንዑስ ክፍል",
                                                description:
                                                  "የመረጃና መዛግብት ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለግንኙነት ክፍል ኃላፊ ነው፡፡"
                                              }
                                            ]
                                        },
                                        {
                                        name: "ሒሳብ እና ንብረት ክፍል",
                                        description:
                                          "የሒሳብ እና ንብረት ክፍል ኃላፊ ተጠሪነቱ ለዋና ሰብሳቢ ነው፡፡",
                                          children: [
                                              {
                                                name: "ሒሳብ ንዑስ ክፍል",
                                                description:
                                                  "የሒሳብ ክፍል ኃላፊ ተጠሪነቱ ለሒሳብና ንብረት ክፍል ኃላፊ ነው፡፡",
                                                  
                                              },
                                              {
                                                name: "ንብረት ንዑስ ክፍል",
                                                description:
                                                  "የንብረት ክፍል ንዑስ ክፍል ኃላፊ ተጠሪነቱ ለጽ/ቤት ኃላፊ ነው፡፡"
                                              },
                                              {
                                                name: "መርሐግብር ክፍል",
                                                description:
                                                  "የመርሐ ግብር ክፍል ኃላፊ ተጠሪነቱ ለዋና ሰብሳቢ ነው፡፡"
                                              }
                                            ]
                                        },
                                        {
                                        name: "የአብነት ት/ቤቶች ድጋፍ ክፍል",
                                        description:
                                          "በኢትዮጵያ ኦርቶዶክስ ተዋህዶ ቤተክርስቲያን ለኢትዮጵያ ህዝብ ዘመን የማይሽረው ሙሉ ትምህርት ፣ ፍጹም ቋንቋ ትርጉም ካላቸው ፊደላት ጋር፣ ያልተበረዘ ቅድስት እምነትን ከነፍልስፍናው፣ ስነ ጽሁፍ ከነጠባዩ፣ በውስጡ ኑፋቄ ያልነካው እውቀትና እግዚአብሔርን መፍራት ያለበትን ጥበብ የተካኑ በስነምግባር የታነጹ በሁለት ወገን የተሳሉ ሊቃውንት አባቶችን አበርክታለች ወይንም አፍርታለች።",
                                          children: [
                                              {
                                                name: "የኦዲዮ ቪዥዋል ን/ክፍል",
                                                description:
                                                  "የኦዲዮ ቪዥዋል ን/ክፍል የአብነት ት/ቤቶችን በተመለከተ ያሉትን ባለሙያዎች በመጠቀም ዶክመንተሪ ይሰራል፣ በማህበሩ አቢይ ኮሚቴ በማጸደቅ ያስተላልፋል፡፡",
                                                  
                                              },
                                              {
                                                name: "የት/ት እና ቅስቀሳ ን/ክፍል",
                                                description:
                                                  "ለማህበሩ አባላትና ለደጋፊ አባላቶች ስለአብነት ት/ቤትና ስለአብነት ትምህርት የግንዛቤ ማስጨበጫ ስራ ይሰራል፡፡"
                                              },
                                              {
                                                name: "የገቢ አሰባሰብ ን/ክፍል",
                                                description:
                                                  "የአብነት ት/ቤቶችን ለመደገፍ የተለያዩ አዳዲስ የገቢ ማስገኛ ሀሳቦችን ያመነጫል፣ ለተግባራዊነታቸው ይሰራል፡፡"
                                              },
                                              {
                                                name: "ስርጭት እና ጥናት ን/ክፍል",
                                                description:
                                                  "የተሰበቡ ድጋፎችን ለአብነት ትምህርት ቤቶች ከማከፋፈሉ በፊት ት/ቤቶቹን ቅድሚያ ለመስጠትና ለመለየት በቦታው በመገኘትና መረጃ በመሰብሰብ ጥናት ያደርጋል፡፡"
                                              }
                                            ]
                                        }
                      ]
              }    
            ]
          }
        ]
      },
      {
        name: "ቶራ የበጎ አድራጎት ድርጅት",
        description:
          "የመጥምቀ መለኮት ቅዱስ ዮሐንስ መንፈሳዊ ማህበር ከያዛቸው ትልቅ ፕሮጀክቶች ውስጥ አንዱ ቶራ የበጎ አድራጎት ድርጅት ሲሆን ማህበሩ ከዚህ በፊት ለአመታት ችግረኛ የሆኑ ቤተሰቦችን በመምረጥ ለነዚህ ቤተሰቦች በየአመቱ ከአባላት በሚደረግ መዋጮ የልጆች ትምህርት ቤት ወጪን በመሸፈንና የትምህርት ቁሳቁሶችን በማሟላት የተወሰኑ ልጆችን ያሳድግ ነበር፡፡"
      },
      {
        name: "ኦዲት እና ኢንስፔክሸን",
        description:
          "የኦዲትና ኢንስፔክሽን ክፍል ኃላፊ ተጠሪነቱ በቀጥታ ለጠቅላላ ጉባኤው ነው፡፡"
      }
    ]
  };
  
// Main Component
export default function Landing() {
    return (
      <div className="landing">
        <span className="left">
          <div className="tree">
            <ul>
              <TreeNode node={organizationData} />
            </ul>
          </div>
        </span>
        <span className="right">
          <div className="organization-description">
              <h2>የማህበሩ አወቃቀር</h2>
              <p>
                  የማህበሩ አወቃቀር በአጠቃላይ ስም እና በተመረጡ ስራዎች ላይ ስለሚሰሩ መረጃ እና መንገዶች በማህበሩ አካላት የተመለከቱ መረጃ ነው። እሱም ምክንያቶችን፣ ስራዎችን፣ ማህበሩን በሚለው አውታረ ብርሃንን አቀረበ። 
              </p>
              <p>
                  ማህበሩ አካላት ይህንን እና እንዲሁም ሌሎች ምሳሌዎችን ለማንኛውም ማህበረሰብ ለአሁን ስራዎች እና ለመንገድ እና በጉባኤው ምላተ ጉባኤው ስም ተመሳሳይ እንደተወከለ መረጃ ስለሆነ የተጠቀሱ ሁሉም መረጃዎች፣ በዚህ በኩል በምላተ ጉባኤው የተስፋፋ በሚለው መሠረት ተመርሷል። 
              </p>
          </div>
      </span>
      </div>
    );
  }